import styled from "styled-components";
import { SectionWrapper, GlobalWrapper } from "shared/Styles/Wrappers";
import { StickyContainer, Sticky } from "react-sticky";

export const Container = styled(GlobalWrapper)`
  background-color: ${({ color }) => (color ? color : "#fff")};
  color: ${({ color }) => (color ? "#fff" : "#000")};
  padding: 64px 0;
`;

export const Wrapper = styled(SectionWrapper)`
  display: flex;
  justify-content: space-between;
  flex-direction: ${({ reverse }) => (reverse ? "row-reverse" : "row")};
  text-align: ${({ reverse }) => (reverse ? "right" : "left")};
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    flex-direction: column;
    justify-content: flex-start;
    text-align: left !important;
  }
`;

export const Column = styled.div`
  width: calc(50% - 24px);
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    width: calc(50% - 18px);
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    width: calc(50% - 12px);
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    width: 100%;
  }
`;

export const StyledStickyContainer = styled(StickyContainer)`
  height: 100%;
  width: 100%;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    & > div > div {
      padding-bottom: 0 !important;
    }
  }
`;

export const StyledSticky = styled(Sticky)``;

export const StickyWrapper = styled.div`
  padding-top: 160px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    padding-top: 140px;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.phone_big}) {
    transform: none !important;
    position: relative !important;
    top: 0 !important;
    left: 0 !important;
    width: 100% !important;
    padding-top: 48px;
  }
`;

export const BigImage = styled.div`
  width: 100%;
  .gatsby-image-wrapper {
    width: 100%;
    height: auto;
  }
`;

export const TextBox = styled.div`
  margin-bottom: 56px;
`;

export const Title = styled.h3`
  font-size: 4rem;
  line-height: 1;
  font-weight: 800;
  margin-bottom: 24px;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 3rem;
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    font-size: 2.4rem;
  }
`;

export const Text = styled.p`
  display: inline;
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.5;

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    font-size: 1.4rem;
  }

  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    font-size: 1.2rem;
  }
`;

export const PhoneBox = styled.div`
  .gatsby-image-wrapper {
    width: 320px;
    height: auto;
    margin-left: auto;
    margin-right: auto;
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.laptop}) {
    .gatsby-image-wrapper {
      width: 240px;
    }
  }
  @media screen and (max-width: ${({ theme }) =>
      theme.breakpoints.tablet_big}) {
    .gatsby-image-wrapper {
      width: 200px;
    }
  }
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    .gatsby-image-wrapper {
      width: 140px;
    }
  }
`;
